import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full text-center font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px] icon flex justify-center mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "p-6 mx-auto mb-4 bg-white rounded-lg shadow-md" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "text-center text-gray-900 black font-sourcesanspro-bold"
}
const _hoisted_7 = { class: "mb-4 text-center" }
const _hoisted_8 = { class: "text-sm text-gray-500" }
const _hoisted_9 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_10 = {
  key: 1,
  class: "text-center text-gray-900 black font-sourcesanspro-bold"
}
const _hoisted_11 = ["innerHTML"]

import { computed, onMounted, ref, watchEffect } from 'vue';
import { IonContent, IonIcon } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

import TopBar from '@/shared/components/TopBar.vue';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import { useRoute } from 'vue-router';
import { anykrowdApi } from '@/api/anykrowdApi';
import useTenant from '@/shared/composables/useTenant';
import { data } from 'autoprefixer';
import useWallet from '@/modules/wallet/composables/useWallet';
import BackButton from '@/shared/components/BackButton.vue';
import router from '@/router';

export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherRefundPage',
  setup(__props) {

const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();

// Init
const { t } = useI18n();
const assetStore = useAssetsStore();
const route = useRoute();
const voucherCode = route.params.id.toString();

const voucherMetaData: any = ref(null);
const voucherAmount = ref('');
const voucherRedeemed = ref(false);
const error = ref('');

// onMountedHook
onMounted(async () => {
	const { data } = await anykrowdApi.get('/vouchers/warranty-voucher-value/' + voucherCode, false);
	if (data && !data.error) {
		try {
			voucherMetaData.value = data.voucher_meta_data;
			voucherAmount.value = parseFloat(data.voucher_meta_data.full_fiat_value).toFixed(2);
			voucherRedeemed.value = data.voucher_meta_data['status'] === 'redeemed' || data.voucher_meta_data['status'] === 'partially_redeemed';
		} catch (e) {
			console.error(e);
		}
	}

	if (data.error === 'invalid_voucher_code') {
		error.value = 'invalid_voucher_code';
	}
});

const { getRefundSchedule } = useWallet();
const { refundSchedule, isFetchedRefundScheduleConfig } = getRefundSchedule();

watchEffect(() => {
	if (isFetchedRefundScheduleConfig.value && (refundSchedule.value === undefined || refundSchedule.value?.refunds_enabled === false)) {
		router.push('/dashboard');
	}
});

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createVNode(BackButton, { to: "/" })
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('wallet.voucher')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(assetStore).logoUrl,
            class: "max-w-[70%]"
          }, null, 8, _hoisted_3)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (error.value === 'invalid_voucher_code')
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('voucher.code_invalid')), 1))
            : _createCommentVNode("", true),
          (!error.value && voucherMetaData.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('wallet.voucher_amount')), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(voucherAmount.value) + " EUR", 1)
                ]),
                (!voucherRedeemed.value && voucherMetaData.value?.within_redeemable_time)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/wallet/refunds/${_unref(voucherCode)}/guestrequest?isVoucher=true`,
                      class: "mx-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          class: "w-[117px] h-[40px] black font-sourcesanspro-semibold text-sm2 ion-no-margin mx-auto",
                          shape: "round"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('wallet.request_refund')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (!voucherMetaData.value?.within_redeemable_time)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(t)('voucher.can_be_redeemed_between')) + " " + _toDisplayString(voucherMetaData.value?.valid_at) + " " + _toDisplayString(_unref(t)('voucher.and')) + " " + _toDisplayString(voucherMetaData.value?.expires_at), 1))
                    : (voucherRedeemed.value)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          class: "text-center text-gray-900 black font-sourcesanspro-bold",
                          innerHTML: _unref(tenantConfig)?.warranty_settings_qr_voucher_redeemed_message ?? _unref(t)('voucher.already_redeemed')
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})